module.exports = __webpack_public_path__ + "static/tabFront@2x-101103179d42e9fa1224e1001250de91.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/tabFront@2x.png
// module id = 2726
// module chunks = 168707334958949